import '.ij{display:inline-block;}.ssr-plugin'
import '.ik{margin-top:1.5rem;}.ssr-plugin'
import '.bp{font-size:0.875rem;}.ssr-plugin'
import '.il{color:var(--palette-blue-500);}.ssr-plugin'
import '.hn{text-decoration:underline;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'

export type DiscoveryCrawlerPaginationFooterProps = {
  nextPageHref: string | null
}

export const DiscoveryCrawlerPaginationFooter = ({
  nextPageHref,
}: DiscoveryCrawlerPaginationFooterProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!nextPageHref || mounted) {
    return null
  }

  return (
    <a className="ij ik bp il hn"
      rel="next"
      href={nextPageHref}
    >
      next page
    </a>
  )
}
